import TutorBiorhythmsImage from "@/assets/img/today/biorhythm/tutor_biorhythms.webp"

import { TodayTimer } from "../today-timer"

interface BiorhythmCountdownProps {
  targetDate?: string | null
}

/** "What are biorhythms?" explainer + next-sync countdown. */
export function BiorhythmCountdown({ targetDate }: BiorhythmCountdownProps) {
  return (
    <>
      <div className="mt-10 px-4">
        <h2 className="font-display text-2xl font-medium text-purple-light">What are biorhythms?</h2>

        <div className="mt-3 flex items-center gap-4">
          <img src={TutorBiorhythmsImage} alt="" className="size-14 shrink-0" />
          <p className="font-body text-base text-purple-light/70">
            Your body and mind follow natural cycles. Track them to stay in sync with your best self -
            physically, emotionally, and mentally.
          </p>
        </div>
      </div>

      <div className="mt-10 px-4">
        <div className="h-px w-full bg-purple-light/20" />

        <div className="mt-6 flex min-h-[51px] items-center gap-4">
          <p className="min-w-0 flex-1 font-body text-base text-purple-light/70">
            Come back tomorrow to sync with your rhythm
          </p>

          {targetDate && <TodayTimer target={targetDate} />}
        </div>
      </div>
    </>
  )
}
